import { Transition, Variants, easeInOut, easeOut } from "framer-motion";

// Fade animations
export const fadeIn: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

export const fadeInUp: Variants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
};

export const fadeInDown: Variants = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
};

export const fadeInLeft: Variants = {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
};

export const fadeInRight: Variants = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
};

// Scale animations
export const scaleIn: Variants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.8 },
};

export const scaleUp: Variants = {
    initial: { scale: 1 },
    animate: { scale: 1.05 },
    exit: { scale: 1 },
};

// Slide animations
export const slideUp: Variants = {
    initial: { y: 100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 100, opacity: 0 },
};

export const slideDown: Variants = {
    initial: { y: -100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -100, opacity: 0 },
};

export const slideLeft: Variants = {
    initial: { x: 100, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 100, opacity: 0 },
};

export const slideRight: Variants = {
    initial: { x: -100, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -100, opacity: 0 },
};

// Height expansion animations
export const expandHeight: Variants = {
    initial: { opacity: 0, height: 0 },
    animate: { opacity: 1, height: "auto" },
    exit: { opacity: 0, height: 0 },
};

// Rotation animations
export const rotateIn: Variants = {
    initial: { opacity: 0, rotate: -180 },
    animate: { opacity: 1, rotate: 0 },
    exit: { opacity: 0, rotate: 180 },
};

export const bounce: Variants = {
    initial: { y: 0 },
    animate: {
        y: [0, -10, 0],
        transition: {
            duration: 0.6,
            repeat: Infinity,
            repeatType: "reverse",
        },
    },
};

// Button specific animations
export const buttonHover: Variants = {
    initial: { scale: 1 },
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 },
};

export const buttonPress: Variants = {
    initial: { scale: 1 },
    whileTap: { scale: 0.95 },
};

// KPI specific animations
export const kpiItem: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    whileHover: { y: -1 },
};

// Container animations for lists (e.g. list of messages)
export const staggerContainer: Variants = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: 0.1,
        },
    },
};

export const staggerItem: Variants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
};

// Transition presets
export const transitions = {
    smooth: { duration: 0.3, ease: easeInOut },
    quick: { duration: 0.15, ease: easeOut },
    slow: { duration: 0.6, ease: easeInOut },
    bounce: { type: "spring", stiffness: 300, damping: 20 },
    elastic: { type: "spring", stiffness: 400, damping: 10 },
};

// Utility function for custom transitions
export const withTransition = (variants: Variants, transition: Transition): Variants => {
    return {
        ...variants,
        animate: {
            ...variants.animate,
            transition,
        },
    };
};
